import { render, staticRenderFns } from "./OperaShopInfoWindow.vue?vue&type=template&id=88bd3ef8&scoped=true&"
import script from "./OperaShopInfoWindow.vue?vue&type=script&lang=js&"
export * from "./OperaShopInfoWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaShopInfoWindow.vue?vue&type=style&index=0&id=88bd3ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bd3ef8",
  null
  
)

export default component.exports